export default {
  countdownTimerContainer: {
    margin: '15px 0 30px',
  },
  countdownTimerProgressBar: {
    margin: '10px 0 15px',
  },
};
